import React, { useEffect, useState, useRef } from "react";
import Header from "../../layouts/Header";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Col, Row } from "react-bootstrap";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import "../../assets/styles/local/InvoicesSettings.css";
import AppDatePicker from "../../components/Common/AppDatePicker";
import DownArrow from "../../assets/icons/downarrow.svg";
import calendar from "../../assets/icons/calendar.svg";
import cInput from "../../assets/icons/c-.svg";
import {
  AddInvoiceSetting,
  FetchInvoiceSettingList,
  FetchInvoiceSettingByid,
  UpdateInvoiceSetting,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import x from "../../assets/icons/x-circle.svg";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import PhoneInput from "react-phone-input-2";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const InvoicesSettings = () => {
  const screenSize = useScreenSize();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const invoicePopupRef = useRef(null);
  const creditPopupRef = useRef(null);

  const companyid = window.localStorage.getItem("companyid");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-Setting").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [paymentDeadline, setPaymentDeadline] = useState(false);
  const [paymentDeadlineValue, setPaymentDeadlineValue] = useState("");
  const [linkModal, setLinkModal] = useState(false);
  const [linkModalValue, setLinkModalValue] = useState("");
  const [invoiceStartDate, setInvoiceStartDate] = useState(new Date());
  const [creditStartDate, setCreditStartDate] = useState(new Date());
  const [invoiceSettingId, setInvoiceSettingId] = useState("");
  const [touched, setTouched] = useState("");
  const [useCompanyEmail, setUseCompanyEmail] = useState(false);
  const [useCompanyAddress, setUseCompanyAddress] = useState(false);
  const [useCompanyPhone, setUseCompanyPhone] = useState(false);
  const [previousEmail, setPreviousEmail] = useState("");
  const [previousAddress, setPreviousAddress] = useState("");
  const [previousPhone, setPreviousPhone] = useState("");

  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [invoiceSerial, setInvoiceSerial] = useState("");
  const [creditSerial, setCreditSerial] = useState("");
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
  const [bankTransfer, setBankTransfer] = useState("");
  const [paymentOptions, setPaymentOptions] = useState([
    "Immediately (0 days)",
    "7 Days",
    "14 Days",
    "15 Days",
    "30 Days",
    "45 Days",
    "60 Days",
  ]);
  const dueDaysOptions = Array.from({ length: 101 }, (_, i) => i); // Generate an array from 0 to 100

  const [selectedDueDays, setSelectedDueDays] = useState("");
  const [description, setDescription] = useState("");
  const [showDueDaysPopup, setShowDueDaysPopup] = useState(false);

  const handleDueDaysChange = (value) => {
    setSelectedDueDays(value);
  };

  const handleDescriptionChange = (value) => {
    setDescription(value);
  };

  const handleAddDueDays = () => {
    const newDueDaysOption = `${selectedDueDays} Days - ${description}`;
    setPaymentOptions((prevOptions) => [...prevOptions, newDueDaysOption]);
    setShowDueDaysPopup(false);
  };
  const FetchInvoiceSettingListResponse = useSelector(
    (state) => state.user.FetchInvoiceSettingListResponse,
  );

  useEffect(() => {
    if (FetchInvoiceSettingListResponse !== null) {
      if (FetchInvoiceSettingListResponse?.status === true) {
        setInvoiceSettingId(
          FetchInvoiceSettingListResponse?.data[0]?.invoiceSettingId,
        );
      }
    }
  }, [FetchInvoiceSettingListResponse]);

  const fetchInvoiceSettingByIdResponse = useSelector(
    (state) => state.user.fetchInvoiceSettingById,
  );

  const applyAddressParts = (data = {}) => {
    setStreet(data.streetWithNumber || data.street || "");
    setCity(data.city || "");
    setState(data.state || "");
    setPinCode(data.pinCode || data.pincode || data.postalCode || "");
    setCountry(data.country || "");
  };

  useEffect(() => {
    if (fetchInvoiceSettingByIdResponse !== null) {
      if (fetchInvoiceSettingByIdResponse?.status === true) {
        const invoiceSetting = fetchInvoiceSettingByIdResponse.data[0];

        setAddress(invoiceSetting.address);
        applyAddressParts(invoiceSetting);
        setPhone(invoiceSetting.telephone);
        setEmail(invoiceSetting.email);
        setInvoiceSerial(invoiceSetting.invoiceSerialNo);

        setInvoiceSerial_No(invoiceSetting.invoiceserialno);
        setCreditSerial_No(invoiceSetting.creditnoteserialno);

        let time = `${invoiceSetting.invoicestartingdate}.000Z`;
        setInvoiceStartDate(new Date(time));
        setCreditSerial(invoiceSetting.creditNoteSerialNo);
        let sTime = `${invoiceSetting.creditstartingdate}.000Z`;
        setCreditStartDate(new Date(sTime));
        setPaymentDeadlineValue(invoiceSetting.paymentDeadline);
        setPaymentDeadline(false);
        if (
          invoiceSetting.paymentOptions === "IDEAL" ||
          invoiceSetting.paymentOptions === "Credit Card"
        ) {
          setLinkModalValue(invoiceSetting.paymentOptions);
          setSelectedPaymentOption("Link");
        } else {
          setSelectedPaymentOption("Bank Transfer");
          setBankTransfer(invoiceSetting.paymentOptions);
        }
      }
    }
  }, [fetchInvoiceSettingByIdResponse]);

  const handlePaymentOptionSelect = (option) => {
    setBankTransfer("");
    setLinkModalValue("");
    setSelectedPaymentOption(option);
  };

  const paymentDeadlineFun = (val) => {
    setPaymentDeadline(false);
    setPaymentDeadlineValue(val);
  };
  const paymentOptionFun = (val) => {
    setLinkModal(false);
    setLinkModalValue(val);
  };

  const linkOptions = ["IDEAL", "Credit Card"];

  useEffect(() => {
    const locationState = location?.state;
    let email = "";
    let address = "";
    let phone = "";

    if (typeof locationState === "string") {
      email = locationState?.split("@@@")[0];
      address = locationState?.split("@@@")[1];
      phone = locationState?.split("@@@")[2];
    } else if (locationState) {
      email = locationState.email;
      address = locationState.address;
      phone = locationState.phonenumber || locationState.phone;
      applyAddressParts(locationState);
    }

    setPreviousEmail(email);
    setPreviousAddress(address);
    setPreviousPhone(phone);
  }, []);

  useEffect(() => {
    dispatch(FetchInvoiceSettingList(companyid, 0, 0));
  }, []);

  useEffect(() => {
    if (invoiceSettingId) {
      dispatch(FetchInvoiceSettingByid(invoiceSettingId));
    }
  }, [invoiceSettingId]);

  const handleSupplierAdd = () => {
    setTouched("");
    const payload = {
      address: address,
      street: street,
      city: city,
      state: state,
      pinCode: pinCode,
      country: country,
      description: "",
      telephone: phone,
      email: email,
      // invoiceserialno: invoiceSerial,
      invoiceserialno: invoiceSerial_No,
      invoicestartinddate: invoiceStartDate,
      // creditserialno: creditSerial,
      creditserialno: creditSerial_No,
      creditstartinddate: creditStartDate,
      paymentdeadline: paymentDeadlineValue,
      paymentoptions:
        selectedPaymentOption === "Bank Transfer"
          ? bankTransfer
          : linkModalValue,
    };
    const updatePayload = {
      invoicesettingid: invoiceSettingId,
      address: address,
      street: street,
      city: city,
      state: state,
      pinCode: pinCode,
      country: country,
      description: "",
      telephone: phone,
      email: email,
      // invoiceserialno: invoiceSerial,
      invoiceserialno: invoiceSerial_No,
      invoicestartinddate: invoiceStartDate,
      // creditserialno: creditSerial,
      creditserialno: creditSerial_No,
      creditstartinddate: creditStartDate,
      paymentdeadline: paymentDeadlineValue,
      paymentoptions:
        selectedPaymentOption === "Bank Transfer"
          ? bankTransfer
          : linkModalValue,
    };
    if (invoiceSettingId) {
      dispatch(UpdateInvoiceSetting(updatePayload));
    } else {
      dispatch(AddInvoiceSetting(payload));
    }
  };
  const addInvoiceSettingRes = useSelector(
    (state) => state.user.addInvoiceSetting,
  );
  useEffect(() => {
    if (addInvoiceSettingRes !== null) {
      if (addInvoiceSettingRes?.status === true) {
        history.push("/settings");
      }
    }
  }, [addInvoiceSettingRes]);

  useEffect(() => {
    if (addInvoiceSettingRes !== null) {
      if (addInvoiceSettingRes?.status === true) {
        dispatch({ type: "ADD_INVOICE_SETTING", data: {} });
      }
    }
  }, []);

  const handleInvoiceSerialChange = (e) => {
    const inputValue = e.target.value;
    // Extract letters and numbers from the current invoiceSerial value
    const letters = inputValue.match(/[A-Za-z]+/) || [];
    const currentNumber = parseInt(inputValue.match(/\d+/) || 0);

    // Increment the number
    const newNumber = currentNumber + 1;

    // Generate the new invoice ID with the same letters and an incremented number
    const newInvoiceID =
      letters.join("") + newNumber.toString().padStart(4, "0");

    // Set the new invoiceSerial value
    if (e.target.name === "invoiceSerial") {
      setInvoiceSerial(newInvoiceID);
    } else {
      setCreditSerial(newInvoiceID);
    }

    setTouched("asc");
  };

  // ASC close dropDown dlick dutside start
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        invoicePopupRef.current &&
        !invoicePopupRef.current.contains(e.target)
      ) {
        setInvoiceSerialShow(false);
        // setArrowOptionsRotate(false);
      }
      if (
        creditPopupRef.current &&
        !creditPopupRef.current.contains(e.target)
      ) {
        setCreditSerialShow(false);
      }
    };

    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  // ASC close dropDown dlick dutside end

  const [invoiceSerialShow, setInvoiceSerialShow] = useState(false);
  const [invoiceSerial_No, setInvoiceSerial_No] = useState("0001");
  const [creditSerialShow, setCreditSerialShow] = useState(false);
  const [creditSerial_No, setCreditSerial_No] = useState("C-0001");

  const Invoices_Serial_No = [
    {
      id: "0001",
      label: "0001",
      value: "0001",
    },
    { id: "YY-0001", label: "YY-0001", value: "YY-0001" },
    {
      id: "IN-YYYY-0001",
      label: "IN-YYYY-0001",
      value: "IN-YYYY-0001",
    },
    {
      id: "INV-YYYYMMDD-001",
      label: "INV-YYYYMMDD-001",
      value: "INV-YYYYMMDD-001",
    },
  ];

  const CreditNote_Serial_No = [
    {
      id: "C-0001",
      label: "C-0001",
      value: "C-0001",
    },
    {
      id: "CYY-0001",
      label: "CYY-0001",
      value: "CYY-0001",
    },
    {
      id: "CN-YYYY-0001",
      label: "CN-YYYY-0001",
      value: "CN-YYYY-0001",
    },
    {
      id: "CRN-YYYYMMDD-001",
      label: "CRN-YYYYMMDD-001",
      value: "CRN-YYYYMMDD-001",
    },
  ];

  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    // history.push("/InvoiceAllList");
    history.goBack();
  };

  // postal Code start

  return (
    <>
      <Header
        // setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Invoices - Default values */}
              {t("Invoices- default values")}
            </p>
          </div>
        }
      />

      {!cancelPopupShow && (
        <RouteLeavingGuard
          when={touched !== ""}
          navigate={(path) => history.push(path)}
          shouldBlockNavigation={(location) => {
            if (touched !== "") {
              if (!["/invoices-settings"].includes(location.pathname)) {
                return true;
              }
            }
            return false;
          }}
        />
      )}

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      <div className="ps-4 pe-4">
        <Row>
          <Col xl={8} lg={8} md={6} sm={12}></Col>
          <Col xl={4} lg={4} md={6} sm={12} className="add-col-item ">
            <div
              className="d-flex cancel_cont_btn"
              onClick={() => {
                if (touched !== "") {
                  setCancelPopupShow(true);
                } else {
                  history.push("/settings");
                }
              }}
              style={{ borderRadius: "12px" }}
            >
              <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                {/* Cancel */}
                {t("Cancel ")}
              </p>
            </div>

            <div
              className="d-flex add-buttons ms-4"
              style={{ borderRadius: "12px" }}
              onClick={handleSupplierAdd}
            >
              <p className="fw-bold mb-0">
                {invoiceSettingId
                  ? // "Update"
                    t("Update")
                  : //  : "Add"
                    t("Add")}
              </p>
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ paddingLeft: "26.58px" }}>
        <div
          className={
            screenSize === "xs"
              ? "table-container-pro-part-mobile"
              : "table-container-pro-part"
          }
        >
          <div>
            <div className="asc-input-container" id="ascInput">
              <div className="company-label-content">
                <div
                  className="company-radio-btn"
                  style={{
                    backgroundColor: useCompanyAddress
                      ? "#00246A"
                      : "transparent",
                  }}
                  onClick={() => {
                    if (useCompanyAddress === false) {
                      setUseCompanyAddress(true);
                      setAddress(previousAddress);
                      if (typeof location?.state === "string") {
                        applyAddressParts();
                      } else {
                        applyAddressParts(location?.state);
                      }
                      setTouched("asc");
                      return;
                    }
                    setUseCompanyAddress(!useCompanyAddress);
                    setTouched("asc");
                  }}
                ></div>
                <span className=" projectNameText">
                  {/* Use company address */}
                  {t("Use Company Address")}
                </span>
              </div>
              <label className="asc-label-top projectNameText">
                {/* Address */}
                {t("Address")}
              </label>
              <GooglePlacesAutocomplete
                debounce={800}
                renderInput={(props) => (
                  <textarea
                    onFocus={() => {
                      setTouched("asc");
                    }}
                    style={{
                      padding: "10px 0",
                      width: "100%",
                      overflow: "hidden",
                      fontSize: "clamp(14px, 0.833vw, 0.833vw)",
                      minHeight: "109px",
                      border: "0.5px solid #70707080",
                    }}
                    {...props}
                    rows={4}
                    placeholder=""
                    className="contactDeliveryInput ps-4 company-address"
                    disabled={useCompanyAddress}
                  />
                )}
                onSelect={async (place) => {
                  const parsed = await parseGooglePlace(place);
                  setAddress(parsed.formattedAddress);
                  applyAddressParts(parsed);
                  setTouched("asc");
                }}
                initialValue={address}
                placeholder=""
              />
            </div>
            <div className="asc-input-container" id="ascInput">
              <div className="company-label-content">
                <div
                  className="company-radio-btn"
                  style={{
                    backgroundColor: useCompanyEmail
                      ? "#00246A"
                      : "transparent",
                  }}
                  onClick={() => {
                    if (useCompanyEmail === false) {
                      setUseCompanyEmail(true);
                      setEmail(previousEmail);
                      setTouched("asc");
                      return;
                    }
                    setUseCompanyEmail(!useCompanyEmail);
                    setTouched("asc");
                  }}
                ></div>
                <span className="projectNameText">
                  {/* Use company email */}
                  {t("Use Company Email")}
                </span>
              </div>
              <label className="asc-label-top projectNameText">
                {/* Email */}
                {t("Email")}
              </label>
              <input
                type="text"
                value={email}
                disabled={useCompanyEmail}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setTouched(e.target.value);
                }}
                className="contactDeliveryInput ps-4 company-address"
                placeholder="Enter Email"
              />
            </div>
            <div className="row align-items-center">
              <div
                className="asc-input-container col-12 col-sm-6"
                id="ascInput"
              >
                <label className="asc-label-top projectNameText">
                  {/* Telephone */}
                  {t("Telephone")}
                </label>
                {/* <input
                  className="contactDeliveryInput ps-4 pt-1 company-address"
                  type="number"
                  value={phone}
                  disabled={useCompanyPhone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setTouched(e.target.value);
                  }}
                  placeholder="Telephone Number"
                /> */}
                <PhoneInput
                  country={"nl"}
                  enableSearch={true}
                  className="contactDeliveryInput ps-4 pt-1 company-address"
                  placeholder="Telephone Number"
                  value={phone}
                  onChange={setPhone}
                />
              </div>
              <div
                className="asc-input-container col-12 col-sm-6"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  className="company-radio-btn"
                  style={{
                    backgroundColor: useCompanyPhone
                      ? "#00246A"
                      : "transparent",
                  }}
                  onClick={() => {
                    if (useCompanyPhone === false) {
                      setUseCompanyPhone(true);
                      setPhone(previousPhone);
                      setTouched("asc");
                      return;
                    }
                    setUseCompanyPhone(!useCompanyPhone);
                    setTouched("asc");
                  }}
                ></div>
                <span className="projectNameText">
                  {/* Use company Telephone */}
                  {t("Use Company Telephone")}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div className="row" style={{ position: "relative" }}>
              <div
                className="asc-input-container col-12 col-sm-6"
                id="ascInput"
                ref={invoicePopupRef}
              >
                <label className="asc-label-top projectNameText">
                  {/* Invoices Serial No. */}
                  {t("Invoices Serial No.")}
                </label>
                {/* <input
                  className="contactDeliveryInput ps-4 pt-1"
                  value={invoiceSerial}
                  name="invoiceSerial"
                  onChange={handleInvoiceSerialChange}
                  placeholder="Enter Invoice No."
                /> */}
                <input
                  readonly
                  className="contactDeliveryInput ps-4 pt-1"
                  value={invoiceSerial_No}
                  name="invoiceSerial"
                  placeholder="Enter Invoice No."
                  onFocus={() => {
                    setInvoiceSerialShow(true);
                  }}
                />
              </div>

              {invoiceSerialShow && (
                <div
                  className="products-and-parts-supplier-customSelect_Outer p-0"
                  style={{
                    width: "210px",
                    height: "170px",
                    top: "67px",
                    // bottom: "10px",
                    left: "12px",
                    fontSize: "13px",
                    border: "1px solid #d1d5db",
                    boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  {Invoices_Serial_No.map((item, index) => {
                    return (
                      <div
                        key={item.id}
                        className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                        onClick={() => {
                          setInvoiceSerial_No(item.label);
                          setInvoiceSerialShow(false);
                        }}
                        style={{
                          backgroundColor:
                            item.label === invoiceSerial_No
                              ? "#F4F5F4"
                              : "transparent",
                          paddingLeft: "12px",
                        }}
                      >
                        {item.label}
                      </div>
                    );
                  })}
                  {Invoices_Serial_No.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!")}
                    </span>
                  )}
                </div>
              )}

              <div
                className="asc-input-container col-12 col-sm-6"
                id="ascInput"
              >
                <label className="asc-label-top projectNameText">
                  {/* Starting Date */}
                  {t("Starting Date")}
                </label>
                <div className="projectManagerInput ps-4 flexContainer">
                  <img
                    className="calendarIcon"
                    onClick={() => {
                      setCalendarIsOpen((p) => !p);
                      setTouched("asc");
                    }}
                    src={calendar}
                    alt=""
                  />
                  <AppDatePicker
                    open={calendarIsOpen}
                    onOpenChange={(open) => setCalendarIsOpen(open)}
                    selected={invoiceStartDate}
                    onChange={(val) => {
                      setInvoiceStartDate(val);
                      setCalendarIsOpen(false);
                    }}
                    onSelect={(d, event) => {
                      setDateError(false);
                      event.preventDefault();
                    }}
                    isError={dateError}
                    error={setDateError}
                    dateFormat="dd/MM/yyyy"
                    // isDisabledForFuture={true}
                    isDisabledForPast={true}
                  />
                </div>
                {dateError && (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <div class="warning-icon">!</div>
                    <div class="warning-message">
                      Please select a valid date.
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row" style={{ position: "relative" }}>
              <div
                className="asc-input-container col-12 col-sm-6"
                id="ascInput"
                ref={creditPopupRef}
              >
                <label className="asc-label-top projectNameText">
                  {/* Credit Note Serial No. */}
                  {t("Credit Notes serial No.")}
                </label>
                {/* <input
                  className="contactDeliveryInput ps-4 pt-1"
                  value={creditSerial}
                  name="creditSerial"
                  onChange={handleInvoiceSerialChange}
                  placeholder="Enter Credit No."
                /> */}
                <input
                  readonly
                  className="contactDeliveryInput ps-4 pt-1"
                  value={creditSerial_No}
                  name="invoiceSerial"
                  placeholder="Enter Credit No."
                  onFocus={() => {
                    setCreditSerialShow(true);
                  }}
                />
                {/* <img
                  style={{ left: "19px", top: "20px" }}
                  className="position-absolute pointer"
                  src={cInput}
                  alt=""
                /> */}
              </div>

              {creditSerialShow && (
                <div
                  className="products-and-parts-supplier-customSelect_Outer p-0"
                  style={{
                    width: "210px",
                    height: "170px",
                    top: "67px",
                    // bottom: "10px",
                    left: "12px",
                    fontSize: "13px",
                    border: "1px solid #d1d5db",
                    boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  {CreditNote_Serial_No.map((item, index) => {
                    return (
                      <div
                        key={item.id}
                        className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                        onClick={() => {
                          setCreditSerial_No(item.label);
                          setCreditSerialShow(false);
                        }}
                        style={{
                          backgroundColor:
                            item.label === creditSerial_No
                              ? "#F4F5F4"
                              : "transparent",
                          paddingLeft: "12px",
                        }}
                      >
                        {item.label}
                      </div>
                    );
                  })}
                  {CreditNote_Serial_No.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!")}
                    </span>
                  )}
                </div>
              )}

              <div
                className="asc-input-container col-12 col-sm-6"
                id="ascInput"
              >
                <label className="asc-label-top projectNameText">
                  {/* Starting Date */}
                  {t("Starting Date")}
                </label>
                <div className="projectManagerInput ps-4 flexContainer">
                  <img
                    className="calendarIcon"
                    onClick={() => {
                      setCalendarIsOpen2((p) => !p);
                      setTouched("asc");
                    }}
                    src={calendar}
                    alt=""
                  />
                  <AppDatePicker
                    open={calendarIsOpen2}
                    onOpenChange={(open) => setCalendarIsOpen2(open)}
                    selected={creditStartDate}
                    onChange={(val) => {
                      setCreditStartDate(val);
                      setCalendarIsOpen2(false);
                    }}
                    onSelect={(d, event) => {
                      setDateError(false);
                      event.preventDefault();
                    }}
                    isError={dateError}
                    error={setDateError}
                    dateFormat="dd/MM/yyyy"
                    // isDisabledForFuture={true}
                    isDisabledForPast={true}
                  />
                </div>

                {dateError && (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <div class="warning-icon">!</div>
                    <div class="warning-message">
                      {/* Please select a valid date. */}
                      {t("Please select a valid date.")}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top projectNameText">
                {/* Payment Deadline */}
                {t("Payment Deadline")}
              </label>
              <input
                type="text"
                value={paymentDeadlineValue}
                className="contactDeliveryInput ps-4"
                onClick={() => setPaymentDeadline(!paymentDeadline)}
                onFocus={() => {
                  setPaymentDeadline(!paymentDeadline);
                  setTouched("asc");
                }}
              />
              {paymentDeadlineValue && (
                <div
                  className="payment-cancel cursor-pointer"
                  onClick={() => setPaymentDeadlineValue("")}
                >
                  X
                </div>
              )}
              {paymentDeadline && (
                <div className="payment-wrp">
                  {paymentOptions.map((option, index) => (
                    <div
                      key={index}
                      className={`payment-sub-item ulterDrop ${
                        paymentDeadlineValue === option ? "selected" : ""
                      }`}
                      onClick={() => paymentDeadlineFun(option)}
                    >
                      {option}
                    </div>
                  ))}
                  <div
                    className="payment-sub-item text-muted"
                    onClick={() => setShowDueDaysPopup(true)}
                  >
                    Other...
                  </div>
                </div>
              )}
            </div>

            {showDueDaysPopup && (
              <div className="due-days-popup">
                <img
                  alt=""
                  src={x}
                  style={{
                    width: "clamp(22px, 1.146vw, 1.146vw)",
                    height: "clamp(22px, 1.146vw, 1.146vw)",
                    cursor: "pointer",
                    alignSelf: "end",
                  }}
                  onClick={() => {
                    setShowDueDaysPopup(false);
                  }}
                />
                <div className="mt-2 position-relative" id="ascInput">
                  <label className="asc-label-top projectNameText">
                    {/* Due days */}
                    {t("Due days")}
                  </label>
                  <select
                    className="contactDeliveryInput ps-4 pt-1"
                    value={selectedDueDays}
                    onChange={(e) => handleDueDaysChange(e.target.value)}
                  >
                    {dueDaysOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mt-2 position-relative" id="ascInput">
                  <label className="asc-label-top projectNameText">
                    {/* Description */}
                    {t("Description")}
                  </label>
                  <input
                    type="text"
                    className="contactDeliveryInput ps-4 pt-1"
                    placeholder="0 Days"
                    value={description}
                    onChange={(e) => handleDescriptionChange(e.target.value)}
                  />
                </div>
                <div
                  className="add-due-buttons"
                  style={{ borderRadius: "12px" }}
                  onClick={handleAddDueDays}
                >
                  <p className="fw-bold mb-0">
                    {/* Add */}
                    {t("Add")}
                  </p>
                </div>
              </div>
            )}

            <div className="asc-input-container contactDeliveryInputOption">
              <label className="asc-label-top projectNameText option-style">
                {/* Payment options */}
                {t("Payment options")}
              </label>

              <div className="asc-input-container mt-0 d-flex flex-column gap-4">
                <div>
                  <div className="company-label-content-radio">
                    <div
                      className="company-radio-btn"
                      style={{
                        backgroundColor:
                          selectedPaymentOption === "Bank Transfer"
                            ? "#00246A"
                            : "transparent",
                      }}
                      onClick={() => {
                        handlePaymentOptionSelect("Bank Transfer");
                        setTouched("asc");
                      }}
                    ></div>
                    <span
                      className="projectNameText cursor-pointer"
                      onClick={() => handlePaymentOptionSelect("Bank Transfer")}
                    >
                      {/* Bank Transfer */}
                      {t("Bank Transfer")}
                    </span>
                  </div>
                  <input
                    type="text"
                    value={bankTransfer}
                    onChange={(e) => {
                      setBankTransfer(e.target.value);
                    }}
                    className="contactDeliveryInput ps-4"
                  />
                </div>
                <div className="position-relative">
                  <div className="company-label-content-radio">
                    <div
                      className="company-radio-btn"
                      style={{
                        backgroundColor:
                          selectedPaymentOption === "Link"
                            ? "#00246A"
                            : "transparent",
                      }}
                      onClick={() => {
                        handlePaymentOptionSelect("Link");
                        setTouched("asc");
                      }}
                    ></div>
                    <span
                      className="projectNameText cursor-pointer"
                      onClick={() => {
                        handlePaymentOptionSelect("Link");
                      }}
                    >
                      {/* Link */}
                      {t("Link")}
                    </span>
                  </div>

                  <input
                    type="text"
                    defaultValue={linkModalValue}
                    className="contactDeliveryInput ps-4 cursor-pointer"
                    onClick={() => {
                      handlePaymentOptionSelect("Link");
                      setLinkModal(!linkModal);
                    }}
                  />
                  {linkModalValue && (
                    <div className="payment-cancel">
                      <img
                        alt=""
                        className="alert-x-icon-pop"
                        style={{ width: "14px" }}
                        src={DownArrow}
                        onClick={() => {
                          setLinkModal(!linkModal);
                        }}
                      />
                    </div>
                  )}
                  {linkModal && (
                    <div className="payment-wrp pt-3 option-payment">
                      <span className="projectNameText payment-sub-item">
                        {/* Choose Link */}
                        {t("Choose Link")}
                      </span>
                      <div className="mt-3">
                        {linkOptions.map((option, index) => (
                          <div
                            key={index}
                            className="payment-sub-item"
                            onClick={() => paymentOptionFun(option)}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicesSettings;
